// extracted by mini-css-extract-plugin
export default {"list":"index_list__zcwBs","ic_back":"index_ic_back__dHyu2","pCard":"index_pCard__G5u+d"};